import { render, staticRenderFns } from "./todo-share.html?vue&type=template&id=5e3c7294&scoped=true&external"
import script from "./todo-share.js?vue&type=script&lang=js&external"
export * from "./todo-share.js?vue&type=script&lang=js&external"
import style0 from "./todo-share.scss?vue&type=style&index=0&id=5e3c7294&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c7294",
  null
  
)

export default component.exports